import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// bundle i18n into app

import "./i18n/i18n";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Defensively unregister any service worker left over from prior deploys.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((rs) => rs.forEach((r) => r.unregister()))
    .catch(() => {});
}
